import Accordion from '@passkeys/ui/accordion';
import Button from '@passkeys/ui/button';
import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';
import { useParams } from 'wouter';

import Collectible from '@/ui/components/collectible';
import Subpage from '@/ui/components/subpage';
import useClaimedPlaygroundSbt from '@/ui/hooks/use-claimed-playground-sbt';
import useNavigate from '@/ui/hooks/use-navigate.js';
import useNft from '@/ui/hooks/use-nft';
import { getChainFromNft } from '@/ui/utils/nfts';
import AttributesTable from './components/attributes-table.js';

function CollectibleDetailPage() {
  const { id } = useParams<{ id: string }>();

  const { loading: loadingSbt, data: collectibleSbt } =
    useClaimedPlaygroundSbt();

  const { data: collectibleNft } = useNft({ id: decodeURIComponent(id) });

  const collectible = collectibleNft || collectibleSbt;

  if (!collectible && !loadingSbt) {
    // TODO: Render 404 page.
    throw new Error('Collectible not found');
  }

  const chain = getChainFromNft(collectible);

  const navigate = useNavigate();

  // TODO: Add loading state.
  return (
    <Subpage title="Collectible" className="flex flex-col gap-6 pb-6">
      {collectible && (
        <>
          <Collectible
            image={collectible.image}
            name={collectible.name}
            collectionName={collectible.collectionName}
            chain={chain}
          />

          {collectibleSbt?.id !== id && (
            <Button
              className="mx-4"
              size="large"
              dataTestId="send-collectible-button"
              onClick={() => navigate(`/collectibles/${id}/send`)}
            >
              <span className="flex items-center gap-3">
                Send
                <Icon name="arrow-up-right" size={16} />
              </span>
            </Button>
          )}

          <Accordion
            summary={
              <>
                <Text className="mb-2" size={14}>
                  Description
                </Text>
                <Text
                  size={14}
                  className="text-black/50 theme-dark:text-white/50"
                  dataTestId="collectible-description"
                >
                  {collectible.description}
                </Text>
              </>
            }
            details={
              <>
                <Text className="mb-2 mt-6" size={14}>
                  Attributes
                </Text>
                <AttributesTable attributes={collectible.attributes} />
              </>
            }
            toggleDataTestId="collectible-accordion-toggle-button"
          />
        </>
      )}
    </Subpage>
  );
}

export default CollectibleDetailPage;
